module.exports = __webpack_public_path__ + "static/official_website_new/img/rotationChart3.e8ad19a7.jpg";